import http from '@/http-common'
import ModalEkp from "@/views/ekpForm/ModalFormEkp"

export default {
  name: "DownloadFile",
  components: {ModalEkp},
  props: {
    pathStr: {
      type: String,
      default: ''
    },
    fileNameOut: {
      type: String,
      default: 'Document'
    },
    fileType: {
      type: String,
      default: '.pdf'
    },
    value: {
      type: Object,
      default: function () {
        return {
          keyFile: '',
          url: '',
          dfileDocument: ''
        }
      }
    }
  },
  data() {
    return {
      file: null,
      widthPdfModal: '50%',
      existsFile: false,
      modalPdfDialogOpened: false
    }
  },
  methods: {
    submitFile() {
      let formData = new FormData();
      if (!this.value.keyFile) {
        this.value.keyFile = Date.now().toString();
      }
      let fileName = this.value.keyFile;
      let vm = this;
      if (this.file) {
        formData.append('file', vm.file);
        http.post('/report/' + vm.pathStr + '?name=' + fileName,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(function (response) {
          let file_name = response.data.name;
          vm.value.keyFile = file_name;
          vm.closeModal();
        }).catch(error => {
          alert(error.message);
        });
      }
    },
    checkFileExists() {
      let vm = this;
      let fileName = '';
      if (this.value.keyFile) {
        fileName = this.value.keyFile;
        if (this.value.keyFile && this.value.keyFile.indexOf('.') < 0) {
          fileName = this.value.keyFile + '.pdf';
        }
      }
      vm.existsFile = false;
      vm.value.dfileDocument = '';
      if (fileName.length > 0) {
        http.get('/report/download/check/' + vm.pathStr + '?name=' + fileName)
        .then(function (response) {
          if (response.data == "exists") {
            vm.existsFile = true;
          }
        }).catch(error => {
        });
      }
    },
    openModal() {
      this.checkFileExists()
      this.modalPdfDialogOpened = true
    },
    closeModal() {
      this.modalPdfDialogOpened = false
    }
  }
}
